var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineConfirmationCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9993 17.9996V13.9996C29.9993 12.8896 29.0993 11.9996 27.9993 11.9996H11.9993C10.8993 11.9996 10.0093 12.8896 10.0093 13.9996V17.9996C11.1093 17.9996 11.9993 18.8996 11.9993 19.9996C11.9993 21.0996 11.1093 21.9996 9.99927 21.9996V25.9996C9.99927 27.0996 10.8993 27.9996 11.9993 27.9996H27.9993C29.0993 27.9996 29.9993 27.0996 29.9993 25.9996V21.9996C28.8993 21.9996 27.9993 21.0996 27.9993 19.9996C27.9993 18.8996 28.8993 17.9996 29.9993 17.9996ZM27.9993 16.5396C26.8093 17.2296 25.9993 18.5296 25.9993 19.9996C25.9993 21.4696 26.8093 22.7696 27.9993 23.4596V25.9996H11.9993V23.4596C13.1893 22.7696 13.9993 21.4696 13.9993 19.9996C13.9993 18.5196 13.1993 17.2296 12.0093 16.5396L11.9993 13.9996H27.9993V16.5396ZM18.9993 22.9996H20.9993V24.9996H18.9993V22.9996ZM18.9993 18.9996H20.9993V20.9996H18.9993V18.9996ZM18.9993 14.9996H20.9993V16.9996H18.9993V14.9996Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineConfirmationCircle40Px);
export default __webpack_public_path__ + "static/media/ic_outline-confirmation_circle-40px.b7c01a4d5d8144cd7b3848f9b66a28a7.svg";
export { ForwardRef as ReactComponent };